import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/EducationLogDetails/api/educationLogDetailsService'
import { EducationLogDetailsState, ApiEducationLogDetailsResponse } from './types'

const initialState: EducationLogDetailsState = {
  data: {},
}

const educationLogDetailsSlice = createSlice({
  name: 'activityLogEducationLogDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiEducationLogDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = educationLogDetailsSlice.actions

export default educationLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
